import { render, staticRenderFns } from "./pdf-canvas.vue?vue&type=template&id=bfdabc0e&scoped=true"
import script from "./pdf-canvas.vue?vue&type=script&lang=js"
export * from "./pdf-canvas.vue?vue&type=script&lang=js"
import style0 from "./pdf-canvas.vue?vue&type=style&index=0&id=bfdabc0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdabc0e",
  null
  
)

export default component.exports